import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDatabase } from '@fortawesome/free-solid-svg-icons';
import { Col, Row, Container } from '@themesberg/react-bootstrap';
import { CounterWidget } from "../../components/Widgets";
import { fetchWithToken } from "../../services/authService";
import { API } from "../../api"; // Импорт API

export default () => {
  const [tableStats, setTableStats] = useState([]);
  const [tableNameMap, setTableNameMap] = useState({});

  const EXCLUDED_TABLES = ["log", "perevod", "test-all-type"]; // ❌ Исключенные таблицы

  // Функция для загрузки таблиц с displayName
  const fetchViewableTables = async () => {
    try {
      const response = await fetchWithToken(`${API.BASE_URL}/viewable-tables`, { method: 'GET' });
      if (Array.isArray(response)) {
        const nameMap = {};
        response.forEach(table => {
          nameMap[table.modelName] = table.displayName;
        });
        setTableNameMap(nameMap);
      } else {
        console.error("Ошибка: API /viewable-tables вернул не массив", response);
      }
    } catch (error) {
      console.error("Ошибка при загрузке доступных таблиц:", error);
    }
  };

  // Функция для загрузки статистики таблиц
  const fetchTableStats = async () => {
    try {
      const response = await fetchWithToken(`${API.BASE_URL}/stats/tables`, { method: 'GET' });

      if (Array.isArray(response)) {
        const processedStats = response
          .filter(table => !EXCLUDED_TABLES.includes(table.tableName)) // ❌ Фильтрация
          .map(table => ({
            ...table,
            translatedName: tableNameMap[table.tableName] || table.tableName
          }));

        setTableStats(processedStats);
      } else {
        console.error("Ошибка: API /stats/tables вернул не массив", response);
        setTableStats([]);
      }
    } catch (error) {
      console.error('Ошибка при получении статистики таблиц:', error);
      setTableStats([]);
    }
  };

  useEffect(() => {
    const loadData = async () => {
      await fetchViewableTables();
      await fetchTableStats();
    };
    loadData();
  }, [tableNameMap]); // Перезапуск при обновлении мапы

  return (
    <Container fluid>
      {/* Блок таблиц */}
      {Array.isArray(tableStats) && tableStats.length > 0 && (
        <Row className="justify-content-md-center">
          {tableStats.map((table, index) => (
            <Col key={index} xs={12} sm={6} md={4} lg={3} className="mb-4 d-flex">
              <CounterWidget
                category={`Таблица: ${table.translatedName}`}
                title={`Записей: ${table.totalRecords}`}
                icon={faDatabase}
                className="w-100"
              />
            </Col>
          ))}
        </Row>
      )}
    </Container>
  );
};
